import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ModeloAlfa from "@/pages/ModeloAlfa";
import ModeloOmega from "@/pages/ModeloOmega";
import Processos from "@/pages/Processos";
import Sobre from "@/pages/Sobre";
import Eventos from "@/pages/Eventos";
import Galeria from "@/pages/Galeria";
import CartPublic from "@/pages/CartPublic";
import FAQ from "@/pages/FAQ";
import Contacto from "@/pages/Contacto";
import Simulador from "@/pages/Simulador";
import Negocio from "@/pages/Negocio";
import UnitPassport from "@/pages/UnitPassport";
import Loja from "@/pages/Loja";
import Produto from "@/pages/Produto";
import Checkout from "@/pages/Checkout";
import LojaSucesso from "@/pages/LojaSucesso";
import LojaCancelado from "@/pages/LojaCancelado";
import { CartProvider } from "@/context/CartContext";
import Entrar from "@/pages/Entrar";
import Registar from "@/pages/Registar";

import { AuthProvider } from "@/context/AuthContext";
import { CmsProvider } from "@/context/CmsContext";
import { LocaleProvider } from "@/context/LocaleContext";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import RoleProtectedRoute from "@/components/RoleProtectedRoute";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminFaq from "@/pages/admin/AdminFaq";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminEvents from "@/pages/admin/AdminEvents";
import AdminChatLeads from "@/pages/admin/AdminChatLeads";
import AdminBrandingProposals from "@/pages/admin/AdminBrandingProposals";
import ConfiguracaoPartilhada from "@/pages/ConfiguracaoPartilhada";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminCartConfigs from "@/pages/admin/AdminCartConfigs";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminEquipments from "@/pages/admin/AdminEquipments";
import AdminComponents from "@/pages/admin/AdminComponents";
import AdminCartRequirements from "@/pages/admin/AdminCartRequirements";
import AdminPartLabel from "@/pages/admin/AdminPartLabel";
import AdminPartLabelSheet from "@/pages/admin/AdminPartLabelSheet";
import PublicPartPage from "@/pages/PublicPartPage";
import AdminServiceRequests from "@/pages/admin/AdminServiceRequests";
import AdminContent from "@/pages/admin/AdminContent";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminIntegrations from "@/pages/admin/AdminIntegrations";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";

import ContaLayout from "@/pages/conta/ContaLayout";
import ContaDashboard from "@/pages/conta/ContaDashboard";
import ContaPerfil from "@/pages/conta/ContaPerfil";
import ContaPedidos from "@/pages/conta/ContaPedidos";
import ContaEquipamentos from "@/pages/conta/ContaEquipamentos";
import ContaCarrinhoDetalhe from "@/pages/conta/ContaCarrinhoDetalhe";
import ContaAssistencia from "@/pages/conta/ContaAssistencia";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <LocaleProvider>
                <CmsProvider>
                    <CartProvider>
                    <BrowserRouter>
                    <Routes>
                        {/* Auth */}
                        <Route path="/entrar" element={<Entrar />} />
                        <Route path="/registar" element={<Registar />} />

                        {/* Public part lookup (QR scan target) */}
                        <Route path="/peca/:partId" element={<PublicPartPage />} />

                        {/* Client backoffice */}
                        <Route
                            path="/conta"
                            element={
                                <RoleProtectedRoute roles={["customer", "prospect", "admin"]}>
                                    <ContaLayout />
                                </RoleProtectedRoute>
                            }
                        >
                            <Route index element={<ContaDashboard />} />
                            <Route path="pedidos" element={<ContaPedidos />} />
                            <Route path="equipamentos" element={<ContaEquipamentos />} />
                            <Route path="carrinhos/:serial" element={<ContaCarrinhoDetalhe />} />
                            <Route path="assistencia" element={<ContaAssistencia />} />
                            <Route path="perfil" element={<ContaPerfil />} />
                        </Route>

                        {/* Admin */}
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                            <Route index element={<AdminDashboard />} />
                            <Route path="users" element={<AdminUsers />} />
                            <Route path="equipments" element={<AdminEquipments />} />
                            <Route path="components" element={<AdminComponents />} />
                            <Route path="service-requests" element={<AdminServiceRequests />} />
                            <Route path="faq" element={<AdminFaq />} />
                            <Route path="testimonials" element={<AdminTestimonials />} />
                            <Route path="events" element={<AdminEvents />} />
                            <Route path="chat-leads" element={<AdminChatLeads />} />
                            <Route path="branding-proposals" element={<AdminBrandingProposals />} />
                            <Route path="newsletter" element={<AdminNewsletter />} />
                            <Route path="contacts" element={<AdminContacts />} />
                            <Route path="cart-configs" element={<AdminCartConfigs />} />
                            <Route path="content" element={<AdminContent />} />
                            <Route path="media" element={<AdminMedia />} />
                            <Route path="settings" element={<AdminSettings />} />
                            <Route path="integrations" element={<AdminIntegrations />} />
                            <Route path="products" element={<AdminProducts />} />
                            <Route path="orders" element={<AdminOrders />} />
                            <Route path="label-plans" element={<AdminPartLabelSheet />} />
                        </Route>
                        {/* Admin — standalone printable pages (no AdminLayout wrapper) */}
                        <Route path="/admin/carts/:cartId/requirements" element={<ProtectedRoute><AdminCartRequirements /></ProtectedRoute>} />
                        <Route path="/admin/parts/:partId/label" element={<ProtectedRoute><AdminPartLabel /></ProtectedRoute>} />

                        {/* Public */}
                        <Route element={<Layout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/modelo-alfa" element={<ModeloAlfa />} />
                            <Route path="/modelo-omega" element={<ModeloOmega />} />
                            <Route path="/processos" element={<Processos />} />
                            <Route path="/eventos" element={<Eventos />} />
                            <Route path="/galeria" element={<Galeria />} />
                            <Route path="/carrinho/:serial" element={<CartPublic />} />
                            <Route path="/sobre" element={<Sobre />} />
                            <Route path="/simulador" element={<Simulador />} />
                            <Route path="/negocios/:slug" element={<Negocio />} />
                            <Route path="/unit/:serial" element={<UnitPassport />} />
                            <Route path="/loja" element={<Loja />} />
                            <Route path="/loja/:slug" element={<Produto />} />
                            <Route path="/checkout" element={<Checkout />} />
                            <Route path="/loja/sucesso" element={<LojaSucesso />} />
                            <Route path="/loja/cancelado" element={<LojaCancelado />} />
                            <Route path="/faq" element={<FAQ />} />
                            <Route path="/contacto" element={<Contacto />} />
                            <Route path="/c/:id" element={<ConfiguracaoPartilhada />} />
                        </Route>
                    </Routes>
                    </BrowserRouter>
                    </CartProvider>
                </CmsProvider>
                </LocaleProvider>
            </AuthProvider>
            <Toaster position="top-right" richColors closeButton />
        </div>
    );
}

export default App;
